import { Controller } from "@hotwired/stimulus"

// Show/hide the password field (Metronic's toggle-password behavior).
export default class extends Controller {
  static targets = ["input", "eye", "eyeSlash"]

  toggle() {
    const reveal = this.inputTarget.type === "password"
    this.inputTarget.type = reveal ? "text" : "password"
    this.eyeTarget.classList.toggle("hidden", reveal)
    this.eyeSlashTarget.classList.toggle("hidden", !reveal)
  }
}
